import LanguageSelector from "components/LanguageSelector"
import UserDropdown from "components/Navbar/UserDropdown"
import Translation from "components/Translation"
import { useAuth } from "context/AuthContext"
import { useTenantContext } from "context/TenantContext"
import { useRouter } from "next/router"
import { SidebarItem } from "pages/dashboard/Sidebar"
import { classNames } from "utils/dom-helpers"
import SidebarItemComponent from "./SidebarItem"
import getConfig from "next/config"

type MobileSidebarProps = {
    show: boolean
    toggleShow(show: boolean): void
}

export default function MobileSidebar(props: MobileSidebarProps) {
    const {
        show,
        toggleShow
    } = props
    const router = useRouter()
    const { sidebar_items, tenant, setSidebarItems } = useTenantContext()
    const { user, POSModal } = useAuth()
    function handleClose() {
        toggleShow(false)
    }
    const { NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig

    function handleOnClick(item: SidebarItem) {
        if (router.pathname == item.route || !item.text) {
            return
        }
        if (item.external_link) {
            window.open(item.external_link, '_blank')?.focus()
            return
        }
        if (item.open_modal) {
            POSModal.open()
            return
        }
        setSidebarItems(sidebar_items.map((i) => {
            return ({...i, selected: item.route == i.route}) 
        }))
        router.push(item.route as string)
        handleClose()
    }

    return (
        <div
            hidden={!show}
        >
            <div
                className="fixed inset-0 bg-gray-800 bg-opacity-70 flex overflow-hidden z-30"
                onClick={handleClose}
            >
                <div
                    className="w-[80%] h-full bg-white rounded-l-xl ml-auto"
                    onClick={(e) => { e.stopPropagation() }}
                >
                    <div className="flex flex-col h-[150px] gap-y-[18px] pt-10 px-5">
                        <div className="flex flex-row justify-between text-center items-center mobilesidemenu">
                            <div className="flex flex-row gap-x-4">
                                <img src={`https://${NEXT_PUBLIC_STATIC_DOMAIN}/images/aot_logo.svg`} alt="logo" />
                                <div className="h-full border border-gray-four" />
                                <LanguageSelector />
                            </div>
                            <button
                                className="feather-x text-primary text-2xl"
                                onClick={handleClose}
                            />
                        </div>
                        <Translation
                            content_key="common.hi_user"
                            content_values={{
                                first_name: user?.first_name as string,
                                last_name: user?.last_name as string
                            }}
                            render_as="div"
                            className="font-medium text-lg text-primary"
                        />
                    </div>
                    <div className="flex flex-row justify-between h-20 p-5 border border-gray-four">
                        <button
                            className='text-[#0168C8] text-sm font-medium rounded-[27px] text-center px-4'
                            style={{
                                background: "linear-gradient(white, white) padding-box, linear-gradient(to right, darkblue, darkorchid) border-box",
                                border: "2px solid transparent",
                            }}
                            onClick={() => {
                                router.push("/get_started")
                            }}
                        >
                            <Translation
                                content_key='common.get_started'
                            />
                        </button>
                        <div className="flex flex-row gap-x-2.5 items-center">
                            <a
                                className="feather-help-circle text-3xl text-gray-600 cursor-pointer"
                                target="_blank"
                                onClick={(e) => {
                                    e.preventDefault()
                                    window.open('http://help.aot.plus/')
                                }}
                            />
                            <UserDropdown />
                        </div>
                    </div>
                    <div
                        className="k-drawer k-drawer-wrapper"
                        style={{
                            height: "calc(100% - 230px)"
                        }}
                    >
                        <div className='k-drawer-items'>
                            <div className="flex flex-row gap-x-3 px-5 py-4">
                                <img
                                    src={tenant?.bizLogoUrl}
                                    alt="tenant logo"
                                    className="w-10 h-10"
                                />
                                <div className="flex flex-col text-sm font-medium text-black-one">
                                    {tenant?.name}
                                </div>
                            </div>
                            {sidebar_items.map((item) => {
                                if (item.text) {
                                    return (
                                        <div
                                            key={item.text}
                                            hidden={item.is_hidden || item.separator}
                                            className={classNames("flex items-center k-drawer-item",
                                                router.pathname == item.route ? "k-state-selected" : "text-gray-600"
                                            )}
                                            role="option"
                                            onClick={() => { handleOnClick(item) }}
                                        >
                                            <SidebarItemComponent
                                                item={item}
                                            />
                                        </div>
                                    )
                                }
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}